// A popstate gate that runs BEFORE Inertia's own listener.
//
// Inertia's router registers its popstate listener on `window` when the app starts, and re-renders (remounts) its page for every
// popstate it sees, or fetches the page again when the entry has no valid state. On `window` itself the browser runs listeners
// in the order they were added (a capture-phase listener added later does NOT jump the queue, checked in Chrome), so a listener a
// component adds when it mounts, long after start-up, can never keep an event from Inertia. This module therefore has to be
// evaluated before the router starts: entrypoints/inertiaAppOptions.js imports it first. It adds ONE listener and does nothing
// until a component claims popstate events (the Opendoor screens' history, see useScreenHistory.js).
let claimed = null

/**
 * Claims popstate events: `handler(event)` runs first for every one, and when it returns true the event is stopped there (Inertia
 * never sees it). Returns the function that gives the events back. One claim at a time: the latest one wins.
 */
export function claimPopstate(handler) {
  claimed = handler
  return () => {
    if (claimed === handler) claimed = null
  }
}

if (typeof window !== "undefined") {
  window.addEventListener("popstate", (event) => {
    if (claimed && claimed(event)) event.stopImmediatePropagation()
  })
}
